<template>

  <b-modal
    id="add-operation-honoraire-modal"
    :ok-title="$t('Add')"
    :title="$t('Add') + ' ' + $t('OperationHonoraire')"
    centered
    ok-only
    ok-variant="primary"
    @ok="handleOk">

    <form ref="operationForm" novalidate>
      <div class="my-2 row">
        <div class="col-md-12">
          <AutocompleteField
            v-model="type"
            :input-class="'medium-label mb-4'"
            :input-id="'type-input'"
            :input-label="$t('operationHonoraire.Type')"
            :items="types"
            :required=true
            @elementValueChanged="getSelectedValueType">
          </AutocompleteField>
        </div>

        <div class="col-md-6">
          <b-form-group
            :label="$t('operationHonoraire.UniteHonoraire')"
            class="medium-label mb-4"
            label-for="uniteHonoraire-input">
            <b-form-select
              id="uniteHonoraire-input"
              v-model="uniteHonoraire"
              required
              @change="handleChangeUniteHonoraire">
              <option v-for="option in unitesHonoraire" :key="option.value" :value="option.value">
                {{ $t(option.text) }}
              </option>
            </b-form-select>
          </b-form-group>
        </div>

        <!-- Mode UNITAIRE -->
        <template v-if="uniteHonoraire === 'UNITAIRE'">
          <div class="col-md-6">
            <b-form-group
              :label="isHT ? $t('operationConstruction.prixHT') : $t('operationConstruction.prixTTC')"
              :label-for="'prixTTC-input'"
              class="medium-label mb-2">
              <b-input-group
                :id="'prixTTC-input'">
                <b-form-input
                  v-model="prixModel"
                  min="0"
                  required
                  step="any"
                  type="number">
                </b-form-input>
                <b-input-group-append>€</b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
        </template>

        <!-- Mode POURCENTAGE_COUT_TRAVAUX -->
        <template v-else-if="uniteHonoraire === 'POURCENTAGE_COUT_TRAVAUX'">
          <div class="col-md-6">
            <b-form-group
              :label="$t('operationConstruction.Pourcentage')"
              :label-for="'pourcentage-input'"
              class="medium-label mb-2">
              <b-input-group
                :id="'pourcentage-input'">
                <b-form-input
                  v-model="pourcentage"
                  v-disable-scroll
                  min="0"
                  max="100"
                  required
                  step="0.01"
                  @change="calculatePercentageValue()"
                  @input="calculatePercentageValue()"
                  type="number">
                </b-form-input>
                <b-input-group-append>%</b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group
              :label="isHT ? $t('operationConstruction.prixHT') : $t('operationConstruction.prixTTC')"
              :label-for="'prixTTC-percentage-input'"
              class="medium-label mb-2">
              <b-input-group
                :id="'prixTTC-percentage-input'">
                <b-form-input
                  v-model="prixTTCInEuros"
                  disabled
                  type="number">
                </b-form-input>
                <b-input-group-append>€</b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
        </template>

        <div class="col-md-6">
          <b-form-group
            :label="$t('operationConstruction.TauxTVA')"
            :label-for="'tauxTVA-input'"
            class="medium-label mb-2">
            <b-form-select
              id="'tauxTVA-input'"
              v-model="tauxTVA"
              required>
              <option v-for="option in filteredTauxTVAList" :key="option.value" :value="option.value">
                {{ $t(option.text) }}
              </option>
            </b-form-select>
          </b-form-group>
        </div>

        <div class="col-md-6">
          <AutocompleteField
            v-model="contactName"
            :input-class="'medium-label mb-2'"
            :input-id="'contact-input'"
            :input-label="$t('operationHonoraire.Contact.Name')"
            :items="contactNames"
            :required=true
            @elementValueChanged="getSelectedValueContact">
          </AutocompleteField>
        </div>
        <div class="col-md-6">
          <b-form-group
            :label="$t('operationHonoraire.date')"
            :label-for="'date-input'"
            :state="stateDate"
            class="medium-label mb-2">
            <datepicker-input
              :id="'date-input'"
              v-model="date"
              :state="stateDate"
              required
              @change="stateDate=null"
              @input="stateDate=null">
            </datepicker-input>
          </b-form-group>
        </div>

        <div
          v-if="operation"
          class="col-md-12 mt-2">
          <b-form-group
            :label="$t('operationConstructions.lots.tolink')"
            :label-for="'lots-input'"
            class="medium-label mb-2">

            <div :id="'lots-input'" class="custom-container">
              <template v-for="(operationLot, index) in operationLots">
                <b-form-checkbox
                  :key="operationLot.id + '-' + selectedLots.includes(operationLot.id)"
                  :ref="'checkbox' + operationLot.id"
                  :checked="selectedLots&&selectedLots.includes(operationLot.id)"
                  @change="handleCheckboxChange(operationLot.id)">
                    <span v-if="operationLot.lotCoPro">{{
                        $t('operation.bilan.Lot') + ' ' + operationLot.lotCoPro
                      }}</span>
                  <span v-else>{{ $t('operation.bilan.Lot') + ' ' + operationLot.lotNumber }}</span>
                </b-form-checkbox>
              </template>
            </div>
          </b-form-group>
        </div>
      </div>
    </form>

  </b-modal>

</template>

<script>

import AutocompleteField from "../../../components/b122/editFields/AutocompleteField";
import DatepickerInput from "../../../components/b122/editFields/DatepickerInput.vue";
import api from "../../../services/api";

export default {

  name: "AddOperationHonoraireModal",

  components: {
    AutocompleteField,
    DatepickerInput
  },

  props: {
    operation: {
      type: Object,
      default: null
    },
    operationLot: {
      type: Array,
      default() {
        return []
      }
    },
    types: {
      type: Array,
      default() {
        return []
      }
    },
    operationLots: {
      type: Array,
      default: () => [],
    },
    contactNames: {
      type: Array,
      default() {
        return []
      }
    },
    tauxTVAList: {
      type: Array,
      default: () => [],
    },
    allInitialDateOperationAndLot: {
      type: Object,
      default: null
    },
    isHT: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      type: null,
      prixTTC: null,
      prixHT: null,
      contactName: null,
      date: null,
      tauxTVA: null,
      stateDate: null,
      selectedLots: this.operationLots.map(lot => lot.id),
      uniteHonoraire: 'UNITAIRE',
      pourcentage: null,
      unitesHonoraire: [
        { value: 'UNITAIRE', text: 'operationHonoraire.unite.UNITAIRE' },
        { value: 'POURCENTAGE_COUT_TRAVAUX', text: 'operationHonoraire.unite.POURCENTAGE_COUT_TRAVAUX' }
      ],
    }
  },

  emits: ['didAddOperationHonoraire'],

  computed: {
    filteredTauxTVAList() {
      if (this.tauxTVAList && this.tauxTVAList.length > 0) {
        return this.tauxTVAList;
      }
      return []
    },


    prixModel: {
      get() {
        return this.isHT ? this.prixHT : this.prixTTC
      },
      set(val) {
        if (this.isHT) {
          this.prixHT = val
        } else {
          this.prixTTC = val
        }
      }
    },

    isPercentageMode() {
      return this.uniteHonoraire === 'POURCENTAGE_COUT_TRAVAUX';
    },

    isPourcentageConstructionMode() {
      return this.uniteHonoraire === 'POURCENTAGE_COUT_TRAVAUX';
    },

    prixTTCInEuros() {
      if (!this.prixTTC || isNaN(this.prixTTC)) return 0;

      if (this.isPercentageMode) {
        return Number(this.prixTTC).toFixed(2);
      }

      return Number(this.prixTTC).toFixed(2);
    }
  },

  async mounted() {
    this.selectedLots = this.operationLots.map(lot => lot.id);
    this.date = this.formatDate(this.allInitialDateOperationAndLot["operation"].estimatedHonoraireDate);
    if (this.operationLot != null) {
      if (this.getInitialDate(this.allInitialDateOperationAndLot, this.operationLot.id, "operationLots", "estimatedHonoraireDate")) {
        this.date = this.getInitialDate(this.allInitialDateOperationAndLot, this.operationLot.id, "operationLots", "estimatedHonoraireDate")
      }
    }
  },

  methods: {

    getSelectedValueType(data) {
      this.type = data
    },
    getSelectedValueContact(data) {
      this.contactName = data
    },

    handleChangeUniteHonoraire() {
      this.prixTTC = null;
      this.pourcentage = null;
    },


    async calculatePercentageValue() {
      if (!this.pourcentage || !this.operation) return;

      try {
        const response = await api.get(`/operationHonoraire/getCoutTravaux?operationId=${this.operation.id}`);
        const baseValue = (response.data.coutTravaux || 0) / 100;

        this.prixTTC = Math.round(baseValue * this.pourcentage / 100).toFixed(2);
      } catch (error) {
        console.error('Erreur lors du calcul du pourcentage:', error);
        this.prixTTC = 0;
      }
    },


    handleOk($event) {
      const form = this.$refs.operationForm;
      if (!form.reportValidity() || !this.date) {
        $event.preventDefault();
        if (!this.date) {
          this.stateDate = false;
        }
        return
      }
      this.handleSubmit();
    },

    handleCheckboxChange(lotId) {
      const index = this.selectedLots.indexOf(lotId);
      if (index === -1) {
        this.selectedLots.push(lotId);
      } else {
        if (this.selectedLots.length > 1) {
          this.selectedLots.splice(index, 1);
        } else {
          this.$refs["checkbox" + lotId][0].checked = true;
          this.$refs["checkbox" + lotId][0].computedLocalChecked = true;
          this.$refs["checkbox" + lotId][0].localChecked = true;
        }
      }
    },

    handleSubmit() {
      if (this.type != null && this.type.trim() !== '' && this.date) {
        let operationHonoraire = {
          operation: this.operation,
          operationLot: this.operationLot,
          type: this.type,
          prixTTC: this.isHT ? null : this.prixModel,
          prixHT: this.isHT ? this.prixModel : null,
          contactName: this.contactName,
          date: this.date,
          tauxTVA: this.tauxTVA,
          isPourcentageConstructionMode: this.isPourcentageConstructionMode,
          id: null,
          selectedLots: this.selectedLots,
          devis: []
        }


        if (this.isPourcentageConstructionMode && this.pourcentage) {
          operationHonoraire.pourcentage = this.pourcentage
        }
        this.$emit('didAddOperationHonoraire', operationHonoraire)
      }
      this.resetModal()
      this.hideModal()
    },

    resetModal() {
      this.type = null
      this.prixTTC = null
      this.prixModel = null
      this.contactName = null
      this.tauxTVA = null;
      this.uniteHonoraire = 'UNITAIRE';
      this.pourcentage = null;
      this.date = this.formatDate(this.allInitialDateOperationAndLot["operation"].estimatedHonoraireDate);
      if (this.operationLot != null) {
        if (this.getInitialDate(this.allInitialDateOperationAndLot, this.operationLot.id, "operationLots", "estimatedHonoraireDate")) {
          this.date = this.getInitialDate(this.allInitialDateOperationAndLot, this.operationLot.id, "operationLots", "estimatedHonoraireDate")
        }
      }
    },

    getInitialDate(source, id, type, dateType) {
      let dateLong = source[type].find(x => x.id === id)[dateType];
      if (dateLong != null) {
        return this.formatDate(dateLong);
      }
      return null;
    },

    formatDate(dateLong) {
      return new Date(Number(dateLong)).toLocaleDateString().split("/").reverse().join("-");
    },

    hideModal() {
      this.$bvModal.hide('add-operation-honoraire-modal')
    }

  }

}

</script>

<style scoped>
.prixTTCContainer {
  padding: 8px 12px;
  background-color: #F4F4F4;
  color: #07153C;
  border: solid 1px #CCCCCC;
}

.prixTTC {
  color: var(--main-color);
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #dc3545;
  padding-right: 0 !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.grey-text {
  color: #AAAAAA;
}

.custom-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.custom-container > * {
  margin-left: 1em;
}
</style>



// WEBPACK FOOTER //
// src/views/operationBilan/components/AddOperationHonoraireModal.vue